import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../NewComponents/Loader";

const NotFound = ({ loadingUser = false, loadingAuth = false, loadingTeam = false }) => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(loadingUser || loadingAuth || loadingTeam){
      setLoading(true);
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [loadingUser, loadingAuth, loadingTeam]);

  if (loading) {
    return (
      <div className="container mx-auto w-full h-dvh flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    
    <div className="container mx-auto h-dvh w-full flex justify-center items-center text-center">
      <div className="flex flex-col gap-4 items-center font-primary">
        <h1 className="text-5xl font-semibold text-primary">
          404 - Page Not Found
        </h1>
        <p className="text-xl font-medium">The page you are looking for doesn't exist.</p>
        <Link className="bg-secondary text-white w-fit px-6 py-2 rounded-full text-lg font-medium" to="/">Go back to Home</Link>
      </div>
    </div>
  );
};

export default NotFound;
